import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import './EcomCarousel.scss';
import {
	BackwardWelCarousel,
	ForwardWelCarousel,
	SendIconButton,
} from '../../../../../../Components/FeatureComponents/Buttons/IconButton/Icons';
import { Carousel } from 'react-responsive-carousel';
const CarouselContainer = styled.div`
	height: 148vw;
	max-height: 570px;
	> .carousel-root {
		height: 100%;
		> .carousel.carousel-slider {
			height: 100%;
		}
	}
	li.slide {
		min-width: 100% !important;
		@media (max-width: 1000px) {
			padding: 10px;
			max-height: 525px;
		}
		> img {
			@media (max-width: 1000px) {
				max-height: 525px;
				object-fit: contain;
				height: 100%;
			}
		}
	}
	.carousel .slide img {
		max-height: 595px;
		object-fit: contain;
	}
	.carousel .control-dots .dot {
		width: 2vw;
		height: 2vw;
		box-shadow: none;
		background-color: transparent;
		border: 1.3px solid var(--black-60);
		&.selected {
			background: #000;
		}
	}
`;

type Props = {
	productImage;
	handleZoom;
	onClose?;
	showBack?;
	theme?;
	showBacktoConv?;
};
const EcomCarousel = ({
	productImage,
	handleZoom,
	onClose,
	theme,
	showBack,
	showBacktoConv,
}: Props) => {
	const [moveClass, setMoveClass] = useState('');
	const [activeIndex, setActiveIndex] = useState(0);
	const images = [
		'https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/25260156/2023/9/29/3d04b8b4-1104-4801-bed4-17ebf98223301695968509595KALINIWomenPinkEthnicMotifsYokeDesignRegularGottaPattiKurtaw1.jpg',
		'https://assets.myntassets.com/dpr_2,q_60,w_210,c_limit,fl_progressive/assets/images/20695836/2022/11/10/ba1724c2-c606-481c-a0ca-63424b61a8661668078028270WomensRayonPrintedEmbroideredKurtaWithPantAndDupatta1.jpg',
		'https://assets.myntassets.com/dpr_2,q_60,w_210,c_limit,fl_progressive/assets/images/23194438/2023/5/15/c8751a5b-54af-49d8-9051-cef942737be01684149792755MiteraWomensBluePolyChiffonDyedSaree1.jpg',
		'https://assets.myntassets.com/dpr_2,q_60,w_210,c_limit,fl_progressive/assets/images/26744124/2023/12/31/eba34dd1-757e-473d-9e7a-d0b957a3382e1704043919883Sarees1.jpg',
	];

	const handleDotClick = (index) => {
		setActiveIndex(index);
	};
	const nextSlide = () => {
		setActiveIndex((prevIndex) =>
			prevIndex === images.length - 1 ? 0 : prevIndex + 1
		);
	};

	const prevSlide = () => {
		setActiveIndex((prevIndex) =>
			prevIndex === 0 ? images.length - 1 : prevIndex - 1
		);
	};

	return (
		<CarouselContainer>
			{showBack && showBacktoConv ? (
				<p
					onClick={() => {
						onClose();
					}}
					style={{
						cursor: 'pointer',
						marginBottom: '8px',
						marginTop: '-14px',
						display: 'flex',
					}}
				>
					<svg
						style={{ marginRight: '10px' }}
						xmlns='http://www.w3.org/2000/svg'
						width='24'
						height='24'
						viewBox='0 0 24 24'
					>
						<g>
							<path
								fill='none'
								d='M312 379.968h24v24h-24z'
								transform='translate(-312 -379.968)'
							/>
							<path
								fill='var(--selectedColor)'
								d='M332 390.968h-12.17l5.59-5.59-1.42-1.41-8 8 8 8 1.41-1.41-5.58-5.59H332z'
								transform='translate(-312 -379.968)'
							/>
						</g>
					</svg>
					Back to Conversations{' '}
				</p>
			) : null}

			<Carousel showArrows={false} showThumbs={false} showStatus={false}>
				{productImage.map((item, index) => {
					return (
						<div
							onClick={() => {
								handleZoom(item);
							}}
						>
							<img src={item} />
						</div>
					);
				})}
			</Carousel>
		</CarouselContainer>
	);
};

export default EcomCarousel;
